module.exports = __webpack_public_path__ + "img/image_cellmate_gen3.733e60a5.png";